import { render, staticRenderFns } from "./xfboxdialog.vue?vue&type=template&id=62b35374&scoped=true&"
import script from "./xfboxdialog.vue?vue&type=script&lang=js&"
export * from "./xfboxdialog.vue?vue&type=script&lang=js&"
import style0 from "./xfboxdialog.vue?vue&type=style&index=0&id=62b35374&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b35374",
  null
  
)

export default component.exports